function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-statements */
import React, { useEffect, useState, useRef } from 'react';
import { Translate } from "../../../../I18N";

import { isString } from 'lodash';
import { InputField, RadioSelect } from '..';
import { Label } from "../Label";
import { Checkbox } from "../Checkbox";
import { MultiselectListButtonItem } from "./MultiselectListButtonItem";
import { MultiselectListGroup } from "./MultiselectListGroup";






























const renderChild = (child) =>
isString(child) ? /*#__PURE__*/_jsx(Translate, {}, void 0, child) : child;

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const MultiselectList = ({
  items,
  onChange,
  className = '',
  label,
  hasErrors,
  value,
  checkboxes = false,
  foldableGroups = false,
  singleSelect = false,
  allowSelelectAll = false,
  startOnSelected = false,
  search = '',
  suggestions = false,
  hideFilters = false,
  itemClassName,
  itemContainerClassName,
  blankState = /*#__PURE__*/_jsx(Translate, {}, void 0, "No items available"),
  lookup
}) => {
  const [selectedValue, setSelectedValue] = useState(value || []);
  const [selecteditems, setSelecteditems] = useState([]);
  const [showAll, setShowAll] = useState(!(startOnSelected && selectedValue.length));
  const [searchTerm, setSearchTerm] = useState('');
  const [externalSearch, setExternalSearch] = useState(search);
  const [filteredItems, setFilteredItems] = useState(items);
  const [openGroups, setOpenGroups] = useState([]);
  const [searching, setSearching] = useState(false);
  const [selectedOrSuggestedItems, setSelectedOrSuggestedItems] = useState(
    new Set(selectedValue)
  );
  const optionsRef = useRef(null);

  useEffect(() => {
    const newSet = new Set(selectedValue);
    const selected = [];
    items.forEach((item) => {
      if (item.suggested) {
        newSet.add(item.value);
      }

      if (item.items) {
        item.items.forEach((subItem) => {
          if (subItem.suggested) {
            newSet.add(subItem.value);
          }
        });
      }
    });

    selectedValue.forEach((val) => {
      const item = filteredItems.find(
        (i) => {var _i$items;return i.value === val || ((_i$items = i.items) === null || _i$items === void 0 ? void 0 : _i$items.some((subitem) => subitem.value === val));}
      );
      if (item) {
        selected.push(item);
      }
    });

    setSelectedOrSuggestedItems(newSet);
    setSelecteditems(selected);
  }, [items, selectedValue]);

  useEffect(() => {
    if (startOnSelected) {
      const groupsToExpand = items.
      filter((item) => {var _item$items;return (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.some((childItem) => value === null || value === void 0 ? void 0 : value.includes(childItem.value));}).
      map((item) => item.value);

      setOpenGroups(groupsToExpand);
    }
  }, [items, value, startOnSelected]);

  useEffect(() => {
    setSearchTerm(search);
    setExternalSearch(search);
  }, [search]);

  useEffect(() => {
    if (externalSearch && searchTerm) {var _optionsRef$current, _optionsRef$current$q;
      (_optionsRef$current = optionsRef.current) === null || _optionsRef$current === void 0 ? void 0 : (_optionsRef$current$q = _optionsRef$current.querySelector('input')) === null || _optionsRef$current$q === void 0 ? void 0 : _optionsRef$current$q.focus();
    }
  }, [externalSearch, filteredItems, searchTerm]);

  useEffect(() => {
    if (value) {
      setSelectedValue(value);
    }
  }, [value]);

  useEffect(() => {
    let filtered = [];

    const filterByLookup = async () => {
      setSearching(true);
      if (lookup && searchTerm) {
        filtered = await lookup(searchTerm);
      }
      selecteditems.forEach((item) => {
        if (!filtered.find((i) => i.value === item.value)) {
          filtered.push(item);
        }
      });
      setSearching(false);
      setFilteredItems(filtered);
    };

    const debouncedFilterByLookup = debounce(filterByLookup, 300);

    if (lookup && searchTerm) {
      debouncedFilterByLookup();
      return;
    }

    const labelIncludesSearch = (_label) => {
      const a = _label.
      toLowerCase().
      normalize('NFD').
      replace(/\p{Diacritic}/gu, '');
      const b = searchTerm.
      toLowerCase().
      normalize('NFD').
      replace(/\p{Diacritic}/gu, '');
      return a.includes(b);
    };

    filtered = items.
    map((item) => {var _item$items2;
      const matchesSearch = !searchTerm || labelIncludesSearch(item.searchLabel);

      const containsChildrenMatchingSearch =
      !searchTerm || ((_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.some((childItem) => labelIncludesSearch(childItem.searchLabel)));

      if (matchesSearch || containsChildrenMatchingSearch) {var _item$items3;
        return _objectSpread(_objectSpread({},
        item), {}, {
          items: (_item$items3 = item.items) === null || _item$items3 === void 0 ? void 0 : _item$items3.filter((childItem) =>
          childItem.searchLabel.toLowerCase().includes(searchTerm.toLowerCase())
          ) });

      }
    }).
    filter((item) => item);

    setFilteredItems(filtered);
  }, [items, searchTerm, lookup, selecteditems]);

  const handleSelect = (_value) => {
    let newValues;
    if (singleSelect) {
      newValues = selectedValue.includes(_value) ? [] : [_value];
    } else {
      newValues = selectedValue.includes(_value) ?
      selectedValue.filter((item) => item !== _value) :
      [...selectedValue, _value];
    }

    setSelectedValue(newValues);
    setExternalSearch('');
    if (onChange) onChange(newValues);
  };

  const handleSelectAll = () => {
    const allValues = [];

    items.forEach((item) => {var _item$items4;
      if ((_item$items4 = item.items) !== null && _item$items4 !== void 0 && _item$items4.length) {var _item$items5;
        (_item$items5 = item.items) === null || _item$items5 === void 0 ? void 0 : _item$items5.forEach((subItem) => allValues.push(subItem.value));
      } else {
        allValues.push(item.value);
      }
    });

    setSelectedValue(allValues);
    if (onChange) onChange(allValues);
  };

  const applyFilter = ({ target }) => {
    setShowAll(target.value === 'true');
  };

  const renderButtonItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }

    const selected = selectedValue.includes(item.value);

    return (/*#__PURE__*/
      _jsx(MultiselectListButtonItem, {

        item: item,
        selected: selected,
        onClick: () => handleSelect(item.value),
        itemClassName: itemClassName }, item.value
      ));

  };

  const renderCheckboxItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }
    const selected = selectedValue.includes(item.value);
    return (/*#__PURE__*/
      _jsx("li", {

        className: `${!selected && searchTerm && !showAll ? 'opacity-70' : ''} ${itemClassName !== null && itemClassName !== void 0 ? itemClassName : ' bg-gray-50 rounded-lg mb-2'} ` }, item.value, /*#__PURE__*/

      _jsx(Checkbox, {
        name: item.value,
        label: item.label,
        checked: selected,
        onChange: () => handleSelect(item.value) }
      )
      ));

  };

  const handleGroupToggle = (groupKey) => {
    if (openGroups.includes(groupKey)) {
      setOpenGroups(openGroups.filter((group) => group !== groupKey));
    } else {
      setOpenGroups([...openGroups, groupKey]);
    }
  };

  const isGroupOpen = (groupKey) => openGroups.includes(groupKey);

  const renderItem = (item) => {var _item$items6;
    const itemHasSelectedChildren = (_item$items6 = item.items) === null || _item$items6 === void 0 ? void 0 : _item$items6.some(
      (childItem) => selectedValue.includes(childItem.value) || childItem.suggested
    );

    if (
    !showAll &&
    !selectedValue.includes(item.value) &&
    !item.suggested &&
    !itemHasSelectedChildren)
    {
      return null;
    }

    return checkboxes ? renderCheckboxItem(item) : renderButtonItem(item);
  };

  const renderGroup = (group) => {var _group$items;
    const isOpen = isGroupOpen(group.value);

    return (/*#__PURE__*/
      _jsx(MultiselectListGroup, {

        label: group.label,
        isOpen: isOpen,
        foldable: foldableGroups,
        onClick: () => handleGroupToggle(group.value),
        itemContainerClassName: itemContainerClassName,
        itemClassName: itemClassName }, group.value, (_group$items =

      group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(renderItem)
      ));

  };

  const renderSelectedLabel = () => {
    if (suggestions) {
      return (/*#__PURE__*/
        React.createElement(React.Fragment, null, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Selected or suggested"), ' ',
        selectedOrSuggestedItems.size ? `(${selectedOrSuggestedItems.size})` : ''
        ));

    }

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Selected"), " ", selectedValue.length ? `(${selectedValue.length})` : ''
      ));

  };

  return (/*#__PURE__*/
    _jsx("div", { className: `relative ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sticky top-0 w-full pt-4 mb-2 bg-white" }, void 0, /*#__PURE__*/
    _jsx(Label, { htmlFor: "search-multiselect", hideLabel: !label, hasErrors: Boolean(hasErrors) }, void 0,
    label
    ), /*#__PURE__*/
    _jsx(InputField, {
      id: "search-multiselect",
      label: "search-multiselect",
      hideLabel: true,
      onChange: (e) => setSearchTerm(e.target.value),
      placeholder: "Search",
      value: searchTerm,
      clearFieldAction: () => setSearchTerm('') }
    ),
    !hideFilters && /*#__PURE__*/
    _jsx("div", { className: "flex mx-1 my-4 flex-nowrap", "data-testid": "multiselectlist-filters" }, void 0, /*#__PURE__*/
    _jsx(RadioSelect, {
      name: "filter",
      orientation: "horizontal",
      options: [
      {
        label: /*#__PURE__*/_jsx(Translate, { "data-testid": "multiselectlist-show-all" }, void 0, "All"),
        value: 'true',
        defaultChecked: !startOnSelected
      },
      {
        label: renderSelectedLabel(),
        value: 'false',
        disabled: selectedOrSuggestedItems.size === 0,
        defaultChecked: startOnSelected
      }],

      onChange: applyFilter,
      className: "flex-grow" }
    ),
    allowSelelectAll && /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "text-gray-400 underline",
      onClick: () => handleSelectAll() }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Select all")
    )

    )

    ),

    filteredItems.length === 0 && !searching && /*#__PURE__*/
    _jsx("div", { className: "flex w-full h-full items-center justify-center min-h-[400px]" }, void 0,
    renderChild(blankState)
    ), /*#__PURE__*/

    React.createElement("ul", { className: `${itemContainerClassName !== null && itemContainerClassName !== void 0 ? itemContainerClassName : ' w-full px-2 pt-2 grow '}`, ref: optionsRef },
    filteredItems.map(renderItem)
    )
    ));

};
export { MultiselectList };